import classNames from 'classnames';
import { useLocation, useNavigate } from 'react-router-dom';
import { DEFAULT_IS_COMPREHENSIVE_NUMBER, DEFAULT_PKG, DEFAULT_TYPE_ID } from './constants';

function FeatureTab() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  if (location.search == '') {
    params.set('type', DEFAULT_TYPE_ID);
    params.set('package', DEFAULT_PKG);
  }

  const typeId = parseInt(params.get('type') || DEFAULT_TYPE_ID);
  const pkg = parseInt(params.get('package') || '0');
  const isComprehensiveNumber = parseInt(
    params.get('comprehensive') || DEFAULT_IS_COMPREHENSIVE_NUMBER
  );
  const isFree = params.get('free') === '1';

  const handleChange = (pkg: boolean | null, isComprehensive: boolean | null, isFree: boolean) => {
    params.delete('number');

    if (pkg === null) {
      params.delete('package');
    } else {
      params.set('package', (+pkg).toString());
    }
    if (isComprehensive === null) {
      params.delete('comprehensive');
    } else {
      params.set('comprehensive', (+isComprehensive).toString());
    }
    if (isFree) {
      params.set('free', '1');
    } else {
      params.delete('free');
    }

    navigate(`${location.pathname}?${params}`);
  };

  if (typeId === 1) {
    const selectedIndex = isComprehensiveNumber > -1 ? isComprehensiveNumber : isFree ? 2 : -1;
    return (
      <div className='mx-auto my-4 flex w-full max-w-md items-center gap-3 sm:px-0'>
        <div className='flex flex-1 gap-1 space-x-0.5 rounded-lg bg-gray-200 p-1'>
          {['تک درس', 'جامع تمرینی', 'رایگان'].map((category, index) => (
            <button
              key={index}
              onClick={() => handleChange(null, index === 2 ? null : index === 1, index === 2)}
              className={classNames(
                'w-full rounded-lg py-2 text-xs font-medium leading-5 text-gray-800 xs:text-sm',
                'ring-white ring-opacity-60 ring-offset-2 ring-offset-gray-600 focus:outline-none focus:ring-2',
                index === selectedIndex
                  ? 'bg-white shadow'
                  : 'text-gray-200 hover:bg-white/[0.12] hover:text-white'
              )}
            >
              {category}
            </button>
          ))}
        </div>
      </div>
    );
  }

  const selectedIndex = pkg === 1 ? 0 : isFree ? 2 : 1;
  return (
    <div className='mx-auto my-4 flex w-full max-w-md items-center gap-3 sm:px-0'>
      <div className='flex flex-1 gap-1 space-x-0.5 rounded-lg bg-gray-200 p-1'>
        {['بسته‌ها (تخفیف ویژه)', 'تک آزمون', 'رایگان'].map((category, index) => (
          <button
            key={index}
            onClick={() => handleChange(index === 2 ? null : index === 0, null, index === 2)}
            className={classNames(
              'w-full rounded-lg py-2 text-xs font-medium leading-5 text-gray-800 xs:text-sm',
              'ring-white ring-opacity-60 ring-offset-2 ring-offset-gray-600 focus:outline-none focus:ring-2',
              index === selectedIndex
                ? 'bg-white shadow'
                : 'text-gray-200 hover:bg-white/[0.12] hover:text-white'
            )}
          >
            {category}
          </button>
        ))}
      </div>
    </div>
  );
}

export default FeatureTab;
